export enum SportIconType {
    Universal,
    AlpineSki,
    AmericanFootball,
    Athletics,
    AussieRules,
    Badminton,
    Bandy,
    Baseball,
    Basketball,
    BeachSoccer,
    Biathlon,
    Bowls,
    Box,
    Canoeing,
    Chess,
    Cricket,
    Curling,
    Cycling,
    Darts,
    Diving,
    Dostihy,
    Double,
    ESporty,
    F1,
    FieldHockey,
    FigureSkating,
    Floorball,
    Football,
    Futsal,
    Golf,
    Handball,
    Hockey,
    Hockeyball,
    Hurling,
    InlineHockey,
    Kabaddi,
    Lakros,
    LeteckaAkrobacia,
    Motosport,
    Netbal,
    Olymp,
    Pessapalo,
    Plachtenie,
    PoharListky,
    Pool,
    Rally,
    Rowing,
    Rugby,
    SkiJumping,
    Snooker,
    SocialStakes,
    Softball,
    Specials,
    Speedway,
    SpolSazky,
    Squash,
    Surfing,
    Swimming,
    Fencing,
    TableTennis,
    Tennis,
    Triathlon,
    Volleyball,
    WaterPolo,
    WaterSlalom,
    Bobsled,
    CrossCountrySkiing,
    FreestyleSkiing,
    NordicCombination,
    Skeleton,
    Sled,
    Snowboarding,
    Speedskating,
    BeachVolley,
    GaelicFootball,
    GaelicHurling,
    GraecoRomanWrestling,
    Skateboarding,
    Archery,
    Weightlifting,
    Strelba,
    OlympiadaPariz,
    SportoveLezenie,
    ElektronickyFutbal,
    Breakdance,
    Zapasenie,
    Vzpieranie
}

export interface IServingCompetitorSportIconMap {  //live icons
    get(key: SportIconType): number;
    has(key: SportIconType): boolean;
}

export const servingCompetitorSportIconMap: IServingCompetitorSportIconMap = (() => {
    // see LiveIcons.png and action-icons.css
    // 1 is hidden, thus for "not applicable"
    let resultSet = new Map<SportIconType, number>();
    resultSet.set(SportIconType.Universal, 1);
    resultSet.set(SportIconType.Hockey, 1);
    resultSet.set(SportIconType.Tennis, 2);
    resultSet.set(SportIconType.Football, 1);
    resultSet.set(SportIconType.Basketball, 1);
    resultSet.set(SportIconType.Volleyball, 5);
    resultSet.set(SportIconType.Handball, 5);
    resultSet.set(SportIconType.Netbal, 5);
    resultSet.set(SportIconType.Futsal, 1);
    resultSet.set(SportIconType.Baseball, 9);
    resultSet.set(SportIconType.AmericanFootball, 10);
    resultSet.set(SportIconType.Badminton, 11);
    resultSet.set(SportIconType.Snooker, 12);
    resultSet.set(SportIconType.Rugby, 10);
    resultSet.set(SportIconType.TableTennis, 14);
    resultSet.set(SportIconType.Darts, 15);
    return resultSet;
})();

export interface ICategoryIconMap {
    [key: number]: SportIconType
}

export const categoryIconMap: ICategoryIconMap =
{
    0: SportIconType.Universal,
    829: SportIconType.Baseball,
    830: SportIconType.Basketball,
    831: SportIconType.Football,
    832: SportIconType.Golf,
    833: SportIconType.Handball,
    834: SportIconType.Hockey,
    835: SportIconType.Motosport,
    836: SportIconType.Tennis,
    837: SportIconType.Volleyball,
    838: SportIconType.AlpineSki,
    839: SportIconType.AmericanFootball,
    840: SportIconType.Athletics,
    841: SportIconType.Badminton,
    842: SportIconType.Bandy,
    843: SportIconType.BeachSoccer,
    844: SportIconType.Biathlon,
    845: SportIconType.Box,
    846: SportIconType.Canoeing,
    847: SportIconType.Curling,
    848: SportIconType.Cycling,
    849: SportIconType.Darts,
    850: SportIconType.F1,
    851: SportIconType.FieldHockey,
    852: SportIconType.FigureSkating,
    853: SportIconType.Floorball,
    854: SportIconType.Futsal,
    855: SportIconType.Hockeyball,
    856: SportIconType.InlineHockey,
    857: SportIconType.Rally,
    858: SportIconType.Rowing,
    859: SportIconType.Rugby,
    860: SportIconType.SkiJumping,
    861: SportIconType.Snooker,
    862: SportIconType.SocialStakes,
    863: SportIconType.Softball,
    864: SportIconType.Swimming,
    865: SportIconType.TableTennis,
    866: SportIconType.Triathlon,
    867: SportIconType.WaterPolo,
    869: SportIconType.Double,
    870: SportIconType.Olymp,
    871: SportIconType.SpolSazky,
    872: SportIconType.Squash,
    873: SportIconType.Surfing,
    874: SportIconType.Bowls,
    875: SportIconType.Lakros,
    876: SportIconType.PoharListky,
    877: SportIconType.Chess,
    878: SportIconType.Cricket,
    879: SportIconType.AussieRules,
    880: SportIconType.Dostihy,
    881: SportIconType.Netbal,
    882: SportIconType.Pessapalo,
    883: SportIconType.Speedway,
    884: SportIconType.WaterSlalom,

    885: SportIconType.Bobsled,
    886: SportIconType.CrossCountrySkiing,
    887: SportIconType.FreestyleSkiing,
    888: SportIconType.NordicCombination,
    889: SportIconType.Skeleton,
    890: SportIconType.Sled,
    891: SportIconType.Snowboarding,
    892: SportIconType.Speedskating,

    893: SportIconType.ESporty,
    894: SportIconType.Hurling,
    895: SportIconType.Kabaddi,
    896: SportIconType.LeteckaAkrobacia,
    897: SportIconType.Plachtenie,
    898: SportIconType.Pool,
    899: SportIconType.Specials,
    900: SportIconType.BeachVolley,
    901: SportIconType.GaelicFootball,
    902: SportIconType.GaelicHurling,
    903: SportIconType.Fencing,

    904: SportIconType.Strelba,
    905: SportIconType.OlympiadaPariz,
    906: SportIconType.SportoveLezenie,
    907: SportIconType.ElektronickyFutbal,
    908: SportIconType.Breakdance,
    909: SportIconType.Zapasenie,
    910: SportIconType.Vzpieranie
}

export const getSportClass = (type?: SportIconType, additionalClass?: string): string => {
    let sportClass = SportIconType[type]
        ? SportIconType[type]
            .split(/(?=[A-Z])/)
            .join('-')
            .toLowerCase()
        : SportIconType[SportIconType.Universal]
            .split(/(?=[A-Z])/)
            .join('-')
            .toLowerCase();
    if (additionalClass) {
        sportClass += ' ' + additionalClass;
    }
    return sportClass;
};

export const getServingCompetitorSportId = (presentationId: number): number => {
    let sportId = categoryIconMap[presentationId];
    if (sportId === undefined || !servingCompetitorSportIconMap.has(sportId)) {
        return 1; // is hidden
    }

    return servingCompetitorSportIconMap.get(sportId);
}

export const getSportClassByPresentationId = (presentationId: number): string => {
    return getSportClass(categoryIconMap[presentationId]);
};
